import type { CollectionsResponse, CollectionItemsResponse, MapFeatureCollection } from "@atlas/shared";
import { apiGet } from "../lib/api-client";

export type {
  Collection,
  CollectionsResponse,
  CollectionItem,
  CollectionMeta,
  CollectionItemsResponse,
} from "@atlas/shared";

export function fetchCollections(): Promise<CollectionsResponse> {
  return apiGet("/collections");
}

export function fetchCollectionItems(
  slug: string,
  params?: { limit?: number; offset?: number },
): Promise<CollectionItemsResponse> {
  const qs = new URLSearchParams();
  if (params?.limit) qs.set("limit", String(params.limit));
  if (params?.offset) qs.set("offset", String(params.offset));
  const q = qs.toString();
  return apiGet(`/collections/${slug}${q ? `?${q}` : ""}`);
}

export function fetchCollectionMap(slug: string): Promise<MapFeatureCollection> {
  return apiGet(`/collections/${slug}/map`);
}

/** Pre-signed link to the shareable collection-progress card (PLT-3). */
export function fetchCollectionShareUrl(slug: string): Promise<{ url: string }> {
  return apiGet(`/collections/${slug}/share-url`);
}
